import { userOrders } from '../../api/api'
import {
  GET_ALL_ORDERS,
  GET_ORDERS_USER,
  DELETE_ORDER,
  UPDATE_STATUS_ORDER,
} from '../actions/globalActions'

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { UserInformations } from './userReducers'

export type OrderDetails = {
  _id: string
  quantity: number
  productId: string
  name: string
  productImg: string
  price: number
}

export type UserOrder = Omit<UserInformations, 'cartItems'> & {
  status: string
  orderDetails: OrderDetails[]
  payment_option: string
  _id: string
  user: string
  totalOrder: number
  createdAt: string
  updatedAt: string
}

export type OrdersUser = {
  success: boolean
  userOrders: UserOrder[]
}

export const getOrdersUser = createAsyncThunk(
  GET_ORDERS_USER,
  async (thunkAPI) => {
    const response = userOrders()
    return (await response)
  }
)

const initialState: OrdersUser = {
  success: false,
  userOrders: []
}

export const orderSlices = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },

  },
  extraReducers: (builders) => {
    builders.addCase(getOrdersUser.fulfilled, (state, action) => {
      state.userOrders = action.payload.data.userOrders
      state.success = action.payload.data.success
    })
  }
})

export const all = orderSlices.actions

export default orderSlices.reducer

